import { DateTime as LuxonDateTime } from 'luxon';

type DateTimeProps = {
    date: Date | string | null | undefined
}

const DateTime = ({ date }: DateTimeProps) => {

    if (date === null || date === undefined ) {
        return null;
    }

    const dt = LuxonDateTime.fromISO((date).toString());

    if (dt.hour + dt.minute + dt.second + dt.millisecond === 0) {
        return <time dateTime={dt.toISO() ?? undefined} title={dt.toLocaleString(LuxonDateTime.DATE_FULL)}>{dt.toLocaleString(LuxonDateTime.DATE_MED)}</time>
    }

    return <time dateTime={dt.toISO() ?? undefined} title={dt.toLocaleString(LuxonDateTime.DATETIME_FULL)}>{dt.toLocaleString(LuxonDateTime.DATETIME_MED)}</time>
};

export default DateTime;